import { GlobalResponseObject } from '@gtpl/shared-models/common-models';

export class FeedBackResponseModel extends GlobalResponseObject {
  data?: any;
  response:any[];
}

export class AllFeedBackResponseModel extends GlobalResponseObject{
  data?: any[];
}

